import {
    CONSULTAR_GLOSAS_ADMIN,
    GLOSAS_CONSULTADAS_ADMIN,
    ERROR_CONSULTANDO_GLOSAS_ADMIN,
    GESTIONAR_GLOSA_ADMIN,
    GESTION_GLOSA_ADMIN_EXITO,
    GESTION_GLOSA_ADMIN_ERROR,
    LIMPIAR_MENSAJES_GLOSAS,
    VENTANA_AYUDA_GLOSA,
    glosasConsultadas,
    errorConsultandoGlosas,
    gestionExito,
    gestionError
} from "./adminGlosaActions";
import { AnyAction } from "redux";
import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { FiltroAdminGlosas } from "../modelo/AdminGlosas";
import { errorAutorizacion } from "src/co/sura/inicio/modulos/inicioActions";
import { SolicitudAdminGlosa, Glosa } from "../modelo/AdminGlosas";

export const consultarGlosasSATEpic = action$ =>
    action$.ofType(CONSULTAR_GLOSAS_ADMIN)
        .mergeMap((action: any) => {

            const url = `sat/consultar/glosas?${obtenerFiltroGlosas(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return glosasConsultadas(respuesta.datosEntidad, respuesta.paginas, respuesta.totalDatos);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoGlosas()];
                });
        });

export const gestionarGlosaSATEpic = action$ =>
    action$.ofType(GESTIONAR_GLOSA_ADMIN)
        .mergeMap((action: any) => {

            const url = `sat/administrar/glosa`;

            return authenticatedAjax
                .post(
                    url,
                    action.solicitud,
                    { 'Content-Type': 'application/json' }
                )
                .map((response) => {
                    return gestionExito();
                }).catch(response => {
                    const respuesta = response.response;
                    const mensajeRespuesta = (respuesta && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                    return [gestionError(mensajeRespuesta)];
                });

        });

export const glosasSATReducer = (state = {
    estado: REQUEST.NONE,
    estadoAccion: REQUEST.NONE,
    mensajeAccion: undefined,
    showAlert: false,
    glosas: [],
    paginas: 0,
    totalParametrosConsulta: 0,
    tamanoPagina: 10,
    paginaActual: 0,
    ventanaAyudaGlosa: undefined
}, action: AnyAction) => {
    switch (action.type) {

        case CONSULTAR_GLOSAS_ADMIN:
            return {
                ...state,
                estado: REQUEST.PENDING,
                glosas: [],
                paginas: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                totalParametrosConsulta: 0,
                paginaActual: action.filtro.paginaActual,
                showAlert: false
            };
        case GLOSAS_CONSULTADAS_ADMIN:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                glosas: action.datosEntidad,
                paginas: action.paginas,
                totalParametrosConsulta: action.totalDatos,
                showAlert: false
            };
        case ERROR_CONSULTANDO_GLOSAS_ADMIN:
            return {
                ...state,
                estado: REQUEST.ERROR,
                glosas: [],
                paginas: 0,
                totalParametrosConsulta: 0,
                showAlert: false
            };
        case GESTIONAR_GLOSA_ADMIN:
            return {
                ...state,
                estado: REQUEST.PENDING,
                parametros: glosaEnGestion(action.solicitud, state.glosas),
                showAlert: false
            };
        case GESTION_GLOSA_ADMIN_EXITO:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                estadoAccion: REQUEST.SUCCESS,
                showAlert: true
            };
        case GESTION_GLOSA_ADMIN_ERROR:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                estadoAccion: REQUEST.ERROR,
                mensajeAccion: action.mensaje,
                showAlert: true
            };
        case LIMPIAR_MENSAJES_GLOSAS:
            return {
                ...state,
                estado: REQUEST.NONE,
                estadoAccion: REQUEST.NONE,
                mensajeAccion: undefined,
                showAlert: false,
                glosas: [],
                paginas: 0,
                totalParametrosConsulta: 0,
                tamanoPagina: 10,
                paginaActual: 0
            };
        case VENTANA_AYUDA_GLOSA:
            return {
                ...state,
                ventanaAyudaGlosa: true
            };
        default:
            return state;
    }
};

const obtenerFiltroGlosas = (filtro: FiltroAdminGlosas) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.servicio) params.set('servicio', filtro.servicio.toString());
        if (filtro.codigoGlosa) params.set('codigoGlosa', filtro.codigoGlosa);
        if (filtro.palabraClave) params.set('palabraClave', filtro.palabraClave);
        if (filtro.tipoGestion) params.set('tipoGestion', filtro.tipoGestion);
        if (filtro.tipoFecha && filtro.fecha && filtro.complementoFecha) {
            params.set(filtro.tipoFecha, filtro.fecha);
            params.set('complementoFecha', filtro.complementoFecha.toString());
        }
        if (filtro.snBloqueante) params.set('snBloqueante', filtro.snBloqueante);
        if (filtro.paginaActual) params.set('pagina', (filtro.paginaActual + 1).toString());
        else params.set('pagina', '1');
        if (filtro.tamanoPagina) params.set('registrosPorPagina', filtro.tamanoPagina.toString());
        else params.set('registrosPorPagina', '10');

    }

    return params.toString();
};

const glosaEnGestion = (solicitud: SolicitudAdminGlosa, glosas: Array<Glosa>) => {
    return glosas.map(glosa => {
        if (glosa.consecutivo === solicitud.datos.consecutivo) {
            glosa.pendiente = true;
        }
        return glosa;
    });
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_glosas/modulos/adminGlosaReducers.ts